import { useTranslation } from 'react-i18next';

import { useGermanStatusBoard } from 'features/Croptimizer/screen/1Board/components/BoardSteps/components/1Status/German/hooks/useGermanStatusBoard';
import MaskInput from 'components/MaskedInput';
import { useStatusBoard } from 'features/Croptimizer/screen/1Board/components/BoardSteps/components/1Status/Standart/hooks/useStatusBoard';

type DoseFieldProps = {
  isGerman?: boolean;
  titleHidden?: boolean;
};

const DoseField = ({ isGerman = false, titleHidden = false }: DoseFieldProps) => {
  const { t } = useTranslation();

  const {
    dose,
    setDose,
    errorDose,
  } = isGerman ? useGermanStatusBoard() : useStatusBoard();

  return (
    <>
      <MaskInput
        titleClassName="top-[-9px] left-[8px]"
        title={titleHidden ? '' : t('dose') + ' (%)'}
        className="w-full"
        value={dose}
        onChange={setDose}
        redBorder={!!errorDose}
        suffix={titleHidden ? ' %' : ''}
        isBlueBg
      />
      <div className="text-[#FF3B30] text-xs ml-1 mt-1 mt-0 h-2">
        {errorDose && <div> {errorDose}</div>}
      </div>
    </>
  ); 
};

export default DoseField;
